import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AppointmentTypeToolTip } from './AppointmentTypeToolTip.js';

var AppointmentTypeToolTipContainer = (_param)=>{
    var { onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "onClick"
    ]);
    const onClickHandler = React.useCallback((e)=>{
        e.preventDefault();
        e.stopPropagation();
        onClick();
        return;
    }, [
        onClick
    ]);
    const onKeyDownHandler = React.useCallback((e)=>{
        if ([
            'Enter',
            ' '
        ].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            onClick();
            return;
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentTypeToolTip, swcHelpers.extends({}, rest, {
        onClick: onClickHandler,
        onKeyDown: onKeyDownHandler
    }));
};

export { AppointmentTypeToolTipContainer, AppointmentTypeToolTipContainer as default };
//# sourceMappingURL=AppointmentTypeToolTipContainer.js.map
